import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import PropTypes from 'prop-types';

import { certsFormattedMessage, getMessageKey } from '../../../utils/utils';
import { getBulkActionFooterBtns } from '../constant';

import { BULK_ACTION_FOOTER_BTNS_REVERSE } from './constant';

function BulkActionCommonHeader({ id, bulkFooterStats }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);

  const buttonKey = BULK_ACTION_FOOTER_BTNS_REVERSE?.[id];
  const buttonObjectsForTotal = getBulkActionFooterBtns(
    campaignType,
    reassignConfigMap
  )[buttonKey]?.objectsToTotal;
  const headerCount = buttonObjectsForTotal?.reduce((total, item) => {
    if (bulkFooterStats[item]) {
      return total + bulkFooterStats[item];
    }

    return total;
  }, 0);

  const renderHeaderText = () => {
    const suffixForCountGreaterThanOne = headerCount > 1 ? 's' : '';

    if (
      id ===
      getBulkActionFooterBtns(campaignType, reassignConfigMap).TERMINATE.id
    ) {
      const messageKey = suffixForCountGreaterThanOne
        ? 'CERTS_BULK_TERMINATE_HEADER_USERS'
        : 'CERTS_BULK_TERMINATE_HEADER_USER';

      return messages.messageKey || localize(intl, getMessageKey(messageKey));
    }

    if (
      id === getBulkActionFooterBtns(campaignType, reassignConfigMap).REJECT.id
    ) {
      const messageKey = suffixForCountGreaterThanOne
        ? 'CERTS_BULK_REJECT_HEADER_ACCESSES'
        : 'CERTS_BULK_REJECT_HEADER_ACCESS';

      return certsFormattedMessage(
        messages.messageKey || localize(intl, getMessageKey(messageKey)),
        {
          count: headerCount || 0,
        }
      );
    }

    if (
      id ===
      getBulkActionFooterBtns(campaignType, reassignConfigMap).DECOMMISSION.id
    ) {
      const messageKey = suffixForCountGreaterThanOne
        ? 'CERTS_BULK_DECOMMISSION_HEADER_ACCESSES'
        : 'CERTS_BULK_DECOMMISSION_HEADER_ACCESS';

      return certsFormattedMessage(
        messages.messageKey || localize(intl, getMessageKey(messageKey)),
        {
          count: headerCount || 0,
        }
      );
    }

    if (
      id ===
        getBulkActionFooterBtns(campaignType, reassignConfigMap).BELONGS_TO_ME
          .id ||
      id ===
        getBulkActionFooterBtns(campaignType, reassignConfigMap).APPROVE.id ||
      id ===
        getBulkActionFooterBtns(campaignType, reassignConfigMap).WORKS_FOR_ME.id
    ) {
      const messageKey = suffixForCountGreaterThanOne
        ? 'CERTS_BULK_APPROVE_HEADER_ACCESSES'
        : 'CERTS_BULK_APPROVE_HEADER_ACCESS';

      return certsFormattedMessage(
        messages.messageKey || localize(intl, getMessageKey(messageKey)),
        {
          count: headerCount || 0,
        }
      );
    }

    const messageKey = suffixForCountGreaterThanOne
      ? 'CERTS_BULK_ACTION_HEADER_ACCESSES'
      : 'CERTS_BULK_ACTION_HEADER_ACCESS';

    return certsFormattedMessage(
      messages.messageKey || localize(intl, getMessageKey(messageKey)),
      {
        count: headerCount || 0,
      }
    );
  };

  return <>{renderHeaderText()}</>;
}

BulkActionCommonHeader.propTypes = {
  id: PropTypes.string.isRequired,
  bulkFooterStats: PropTypes.shape({}),
};

BulkActionCommonHeader.defaultProps = { bulkFooterStats: {} };

export default BulkActionCommonHeader;
